import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { getDefaultBillingProfile } from './get-default-billing-profile';

export async function UpdateBillingProfileName(
    firstName: string,
    lastName: string,
    dependencies: DependenciesPayload,
): Promise<void> {
    const { clientSdk } = dependencies;
    try {
        const { id: billingProfileId } =
            await getDefaultBillingProfile(dependencies);
        await clientSdk.commerce.billing.updateBillingProfile(
            billingProfileId,
            {
                billingProfileName: {
                    firstAndLastName: {
                        firstName,
                        lastName,
                    },
                },
            },
        );
    } catch (error: any) {
        /**
         * TODO:
         * Log error to error logger (not analytics).
         */
        throw new Error('SYSTEM');
    }
}
